import { useCallback } from "react";
import { ACN } from "../../core/form/ACN";
import { Text } from "../../core/form/Text";
import { useConditional } from "../../core/hooks/useConditional";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { useSaveAwareness } from "../../core/hooks/useSaveContext";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { first } from "../../core/utils/array";
import { FormInline, prepareFormDataForSave } from "../../data-entry/FormModal";
import { DateCol, GenericCol } from "../../layout/TableCells";
import { Company, Name, Trust } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { parseTrackedItems } from "./parseTrackedItem";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { Addresses } from "./Address";
import { Tab, TabContainer } from "../../core/ui/Tab";
import { CompanyOfficers } from "./CompanyOfficer";
import { CompanyShareholders } from "./CompanyShareholder";
import { TrustTrustees } from "./TrustTrustees";


export function TrustEdit(props: {
	trust: Trust,
}) {

	const { trust } = props;

	const names = parseTrackedItems(trust.names);
	const name = first(names.active);
	if (!trust.names) trust.names = [];

	if (!trust.addresses) trust.addresses = [];

	if (!trust.unitHolders) trust.unitHolders = [];
	if (!trust.appointors) trust.appointors = [];
	if (!trust.beneficiaries) trust.beneficiaries = [];
	if (!trust.trustees) trust.trustees = [];


	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title="Edit Trust Name"

				arr={trust.names}
				initialValues={name}

				canHaveOnlyOneActive={true}

				form="entity-company-name-edit"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title="Name History"
				onClose={history.close}
				items={trust.names}
				cols={[
					GenericCol("Name", "name"),
				]}
			/>
		);
	})	

	return (
		<TabContainer displayStyle="border-indent">
			<Tab title="Details">
				<div className="flex horiz align-start gap-10 space-evenly">
					<TrackedItemDisplay
						title="Name"
						item={name}
						edit={edit}
						history={history}
						className="bold"
					>
						{
							formatData(
								name ? 
								{
									lines: [ { parts: [ name.name ]} ]
								}
								: undefined
							)
						}
					</TrackedItemDisplay>
					<FormInline
						form="entity-trust-edit"
						obj={props.trust}
					/>
				</div>
			</Tab>

			<Tab title="Addresses">
				<div className="flex horiz align-start gap-10 space-evenly">
					<Addresses
						addressType="physical"
						addresses={trust.addresses}
					/>				
				</div>
			</Tab>

			<Tab title="Trustees">
				<TrustTrustees trustees={props.trust.trustees} />
			</Tab>
			{/* <Tab title="Shareholders">
				<CompanyShareholders shareholders={props.company.shareHolders} />
			</Tab> */}

			<Tab title="Relationships">

			</Tab>
			<Tab title="Documents">

			</Tab>
		</TabContainer>
	);
}